/**
 * <back-to-top>
 * The round button that straddles the boundary between the benefits bar and the
 * footer (see sections/footer-benefits.liquid). Scrolls the page back to the top.
 *
 * Kept as a custom element rather than an inline handler so the markup stays
 * static and the behaviour is progressive: without JS the button simply does
 * nothing visible, so it is hidden until the element upgrades.
 *
 * Scrolls through `@theme/scroll-container` rather than `window`: from 990px up
 * the theme's squeeze layout makes `.page-wrapper` the scroll container and locks
 * `html`/`body` to the viewport, so `window.scrollTo` is a no-op on desktop.
 */
import { scrollTo } from '@theme/scroll-container';
import { prefersReducedMotion } from '@theme/utilities';

class BackToTop extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    if (!this.button) return;

    this.button.addEventListener('click', this.handleClick);
    this.setAttribute('data-ready', '');
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.handleClick);
  }

  handleClick = () => {
    scrollTo({ top: 0, behavior: prefersReducedMotion() ? 'instant' : 'smooth' });
  };
}

if (!customElements.get('back-to-top')) {
  customElements.define('back-to-top', BackToTop);
}
